// extracted by mini-css-extract-plugin
export default {"page-body":"Profile_page-body__61G54","config-container":"Profile_config-container__2ZU6L","side-panel":"Profile_side-panel__OEw+N"};